export default {"src":"/_next/static/media/facebook.22d67de4.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};